import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule, formatDate  } from '@angular/common';
import { InicioService } from '../../../services/inicio.service';
import { appsettings } from '../../../settings/appsettings';
import { ModalComponent } from "../../modal/modal.component";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lista-perfil',
  standalone: true,
  imports: [ModalComponent, CommonModule],
  templateUrl: './lista-perfil.component.html',
  styleUrl: './lista-perfil.component.css'
})
export class ListaPerfilComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() vuelve_2 = new EventEmitter<any>();
  @Input() datos_perfil?: any;
  @Input() color?: any;
  @Input() iconos?: any;
  @Input() idMotor?: any;

  private srvLogin = inject(InicioService);
  private modalService = inject(NgbModal);
  private contentCargando: NgbModalRef | undefined;
  url = appsettings.apiUrl;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  errorMessage: string = '';
  perfilesList: any = [];
  ofertasList: any = [];
  nombre_perfil: string = '';

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.srvLogin.listarPerfiles(this.idMotor, this.datos_perfil.id_perfil_productivo).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.perfilesList = rs.data;
        console.table(rs.data);
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });

  }

  informacion(content: TemplateRef<any>, datos: any) {
    //console.table(datos)
    this.ofertasList = datos.formaciones;
    this.nombre_perfil = datos.nombre_oferta_formativa;
		//this.contentCargando = this.modalService.open(content, { fullscreen: true });
    this.contentCargando = this.modalService.open(content, { size: 'xl' });

	}

  volver(){
    this.vuelve_2.emit({value: false, validador: false});
  }

}
